import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/emain/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/emain/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/emain/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/emain/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/emain/${Id}`);
  },
};
